YUI.add('disclosure', function (Y) {

"use strict";


var SUB = "disclosure",
    INFO = "info",
    $ = Y.one,
    HASH = "#",
    DOT = ".",
    DISCLOSURE_TRIGGER = "ksu-disclosure-trigger",
    DISCLOSURE_TRIGGER_ACTIVE = "ksu-disclosure-trigger-active",
    DISCLOSURE_BODY = "ksu-disclosure-body",
    DISCLOSURE_BODY_ACTIVE = "ksu-disclosure-body-active",


getHeight = function(node) {

    var height, parentwidth;

    if (!node) {
        return 0;
    }

    try {
        parentwidth = node.ancestor().get('region').width;
    } catch(e) {
        parentwidth = "500";
    }
    parentwidth = parentwidth - parseInt(node.getStyle('borderLeftWidth'),10)
                              - parseInt(node.getStyle('marginLeft'),10)
                              - parseInt(node.getStyle('marginRight'),10)
                              - parseInt(node.getStyle('paddingLeft'),10)
                              - parseInt(node.getStyle('paddingRight'),10)
                              - parseInt(node.getStyle('borderRightWidth'),10);
    parentwidth = parentwidth + "px";
    //console.log(parentwidth);
    node.setStyles({position:'absolute',display:'block',visibility:'hidden' ,width:'473px',height:'auto'});
    height = node.getComputedStyle('height');
    // TODO: it would seem redundant to set the style, then remove the attribute.
    node.setStyles({position:'static',display:'block',visibility:'visible'});
    node.removeAttribute('style');

    // YUI's transition module doesn't like fractional pixels, so round up here.
    height = (parseInt(height, 10)+0.99) + "px";

    //console.log("calculated height", height);
    return height;
},


getBody = function(trigger) {

    return trigger.next(DOT+DISCLOSURE_BODY);

},


open = function(trigger, body) {

    var naturalheight;

    Y.log("opening disclosure " + trigger, INFO, SUB);

    /*
     * If no trigger was specified, silently return.
     */
    if (!trigger) {
       return;
    }

    /*
     * If no body was specified, find the body corresponding to this trigger.
     */
    if (!body) {
        body = getBody(trigger);
    }


    naturalheight = getHeight(body);
    //console.log("height", naturalheight);

    //body.setStyle('height', '1px');
    Y.Transition.useNative = false;
    body.transition({
        duration: 0.3,
        easing: 'ease-out',
        height: naturalheight,
        on: {
            start: function() {
                body.setStyle('height', '0');
                body.addClass(DISCLOSURE_BODY_ACTIVE);
                trigger.addClass(DISCLOSURE_TRIGGER_ACTIVE);
            },
            end: function() {
                //console.log("Removing style attr");
                //body.setStyle('height', 'auto');
                body.removeAttribute('style');
            }
        }
    });

},


close = function(trigger, body) {

    Y.log("closing disclosure " + trigger, INFO, SUB);

    if (!body) {
        body = getBody(trigger);
    }

    Y.Transition.useNative = false;
    body.transition({
        duration: 0.3,
        easing: 'ease-out',
        height: '0',
        on: {
            start: function() {},
            end: function() {
                console.log("ending closure");
                body.removeClass(DISCLOSURE_BODY_ACTIVE);
                body.removeAttribute('style');
                trigger.removeClass(DISCLOSURE_TRIGGER_ACTIVE);
            }
        }
    });

},


openAll = function(trigger) {

    var body = $('body'),
    PARENT_NODE = "parentNode";

    while(trigger && trigger !== body) {
        if (trigger.hasClass(DISCLOSURE_TRIGGER)) {
            open(trigger);
        }
        trigger = trigger.get(PARENT_NODE);
    }
},


toggle = function(trigger) {

    var body, visible;

    body = getBody(trigger);
    visible = body.hasClass(DISCLOSURE_BODY_ACTIVE);

    if (visible) {
       close(trigger, body);
    } else {
       open(trigger, body);
    }

},


handleDisclosure = function(evt) {

    var target;

    /*
     * If this is a keypress event, ignore all keys except enter.
     */
    if (evt.type==='keypress' && evt.charCode!==13) {
        return;
    }

    if (evt.type==="click" && evt._event && evt._event.clientX===0 && evt._event.clientY===0) {
        // This is a simulated event triggered by the node focus manager.
        // Ignore it, because the keypress event will do the job.
        return;
    }

    evt.preventDefault();
    target = evt.currentTarget;

    toggle(target);

},


prepare = function(container) {

    var nodes;

    if (!container) {
        container = $("body");
    }

    nodes = container.all(DOT+DISCLOSURE_TRIGGER);
    nodes.setAttribute("tabindex", "0");
},


openId = function(id) {

    var el;

    el = $(HASH+id);
    //console.log("Disclosure.open", id, el);
    if (el && el.hasClass(DISCLOSURE_TRIGGER)) {
        open(el);
    }

},


Disclosures = function() {

    Y.delegate('click', handleDisclosure, "#ksu-inner-wrapper", DOT+DISCLOSURE_TRIGGER);
    Y.delegate('keypress', handleDisclosure, "#ksu-inner-wrapper", DOT+DISCLOSURE_TRIGGER);
    prepare();

};

Y.namespace("Disclosures").init = Disclosures;
Y.Disclosures.prepare = prepare;
Y.Disclosures.open = open;
Y.Disclosures.openAll = openAll;


}, '2.0.0', {"requires": ["node", "base", "transition"]});
